import classNames from "classnames";
import React from "react";

export type TagSizes = "normal" | "larger";

interface Props {
  color: string
  label: string
  size?: TagSizes
  title?: string
  selected?: boolean
  style?: React.CSSProperties
  onClick?: () => void
}

const Tag = ({ color, label, style, size = "normal", title, onClick, selected }: Props) => {
  const cssClasses = classNames("s1_tag", {
    larger: size === "larger",
    "darkgray-bg": color === "darkgray",
    "gray-bg": color === "gray",
    "red-bg": color === "red",
    "blue-bg": color === "blue",
    "green-bg": color === "green",
    "orange-bg": color === "orange",
    "purple-bg": color === "purple",
    "green-basic s1_transparent": color === "green-basic-disabled",
    "green-basic": color === "green-basic",
    "blue-basic": color === "blue-basic",
    "red-basic": color === "red-basic",
    "purple-basic": color === "purple-basic",
    selected,
    "not-selected": !selected
  });

  const backgroundColor = (color.startsWith("#")) ? color : null;

  return (
    <div
      className={cssClasses}
      style={{
        backgroundColor,
        cursor: onClick ? "pointer" : undefined,
        ...style
      }}
      onClick={onClick}
      title={title}>
      {label}
    </div>
  );
};

export default Tag;